import dailyStatement from './daily-statement.vue'

export default dailyStatement
